export function getText(payment) {
  return `with cash${payment.payment_type ? ` (${payment.payment_type_record.name})` : ''}`
}
